import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

const ServiziPage = () => {
  const services = [
    {
      title: 'Distribuzione B2B',
      description: 'Forniamo prodotti tecnologici all\'ingrosso a rivenditori, system integrator e aziende con listini dedicati e condizioni commerciali vantaggiose.',
      icon: 'ri-store-line',
      color: 'blue',
      features: ['Listini Riservati B2B', 'Ordini Minimi Flessibili', 'Pagamenti Dilazionati', 'Account Manager Dedicato']
    },
    {
      title: 'Consegne Rapide',
      description: 'Spedizioni veloci in tutta Italia con tracking completo. Consegne espresse disponibili per ordini urgenti con ritiro in 24 ore.',
      icon: 'ri-truck-line',
      color: 'green',
      features: ['Consegna 24-48h', 'Tracking in Tempo Reale', 'Spedizioni Assicurate', 'Ritiro in Sede']
    },
    {
      title: 'Assistenza Tecnica',
      description: 'Supporto tecnico pre e post vendita con consulenza specializzata per la scelta dei prodotti più adatti alle tue esigenze.',
      icon: 'ri-customer-service-2-line',
      color: 'purple',
      features: ['Consulenza Tecnica', 'Supporto Pre-Vendita', 'Assistenza Post-Vendita', 'Configurazione Prodotti']
    },
    {
      title: 'Garanzia Ufficiale',
      description: 'Tutti i nostri prodotti sono coperti da garanzia ufficiale del produttore con assistenza diretta in Italia.',
      icon: 'ri-shield-check-line',
      color: 'red',
      features: ['Garanzia Produttore', 'Assistenza in Italia', 'Sostituzione Rapida', 'Estensione Garanzia']
    },
    {
      title: 'Fatturazione Elettronica',
      description: 'Gestione completa della fatturazione elettronica B2B con invio immediato e archiviazione digitale conforme alle normative.',
      icon: 'ri-file-text-line',
      color: 'orange',
      features: ['Fattura Elettronica', 'Invio Immediato', 'Archiviazione Digitale', 'Estratti Conto']
    },
    {
      title: 'Consulenza Personalizzata',
      description: 'Analizziamo le tue esigenze per proporti le soluzioni tecnologiche più adatte al tuo business con preventivi su misura.',
      icon: 'ri-lightbulb-line',
      color: 'indigo',
      features: ['Analisi Esigenze', 'Preventivi Personalizzati', 'Soluzioni su Misura', 'Progetti Chiavi in Mano']
    }
  ];

  const getColorClasses = (color: string) => {
    const colors: { [key: string]: { bg: string; text: string; border: string } } = {
      blue: { bg: 'bg-blue-100', text: 'text-blue-600', border: 'border-blue-600' },
      green: { bg: 'bg-green-100', text: 'text-green-600', border: 'border-green-600' },
      purple: { bg: 'bg-purple-100', text: 'text-purple-600', border: 'border-purple-600' },
      red: { bg: 'bg-red-100', text: 'text-red-600', border: 'border-red-600' },
      orange: { bg: 'bg-orange-100', text: 'text-orange-600', border: 'border-orange-600' },
      indigo: { bg: 'bg-indigo-100', text: 'text-indigo-600', border: 'border-indigo-600' },
    };
    return colors[color] || colors.blue;
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <section className="pt-32 pb-16 bg-gradient-to-br from-blue-600 to-blue-800 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">I Nostri Servizi</h1>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto leading-relaxed">
            Offriamo servizi completi per supportare il tuo business con soluzioni professionali, assistenza dedicata e condizioni commerciali vantaggiose.
          </p>
        </div>
      </section>
      
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => {
              const colorClasses = getColorClasses(service.color);
              return (
                <div
                  key={index}
                  className="bg-white rounded-2xl shadow-lg p-8 hover:shadow-2xl transition-all border-2 border-gray-100 hover:border-gray-200"
                >
                  <div className={`w-16 h-16 ${colorClasses.bg} rounded-full flex items-center justify-center mb-6`}>
                    <i className={`${service.icon} text-3xl ${colorClasses.text}`}></i>
                  </div>
                  
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">{service.title}</h3>
                  <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>
                  
                  <ul className="space-y-3">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start">
                        <i className={`ri-check-line ${colorClasses.text} mr-2 mt-1 flex-shrink-0`}></i>
                        <span className="text-sm text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-r from-blue-600 to-blue-800 rounded-3xl p-12 md:p-16 text-center text-white shadow-2xl">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">Perché Scegliere Amaca S.r.l.</h2>
            <p className="text-xl text-blue-100 mb-10 max-w-3xl mx-auto leading-relaxed">
              Siamo il partner ideale per il tuo business tecnologico grazie alla nostra esperienza, professionalità e attenzione al cliente.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-10">
              <div>
                <div className="text-5xl font-bold mb-2">5000+</div>
                <div className="text-blue-100">Prodotti Disponibili</div>
              </div>
              <div>
                <div className="text-5xl font-bold mb-2">500+</div>
                <div className="text-blue-100">Clienti Attivi</div>
              </div>
              <div>
                <div className="text-5xl font-bold mb-2">24-48h</div>
                <div className="text-blue-100">Consegna Media</div>
              </div>
              <div>
                <div className="text-5xl font-bold mb-2">5+</div>
                <div className="text-blue-100">Anni Esperienza</div>
              </div>
            </div>
            
            <Link
              to="/contatti"
              className="inline-flex items-center bg-white text-blue-600 px-10 py-4 rounded-xl text-lg font-semibold hover:bg-gray-100 transition-all shadow-lg whitespace-nowrap cursor-pointer"
            >
              Richiedi Informazioni
              <i className="ri-arrow-right-line ml-3"></i>
            </Link>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default ServiziPage;
